import { http, type AxiosResponse } from './http'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getEnv, getLocationEnv } from './env'
import { encode} from 'js-base64'
/**
 *  获取全路径
 * @param filePath 附件地址
 * @returns  全路径
 */

export const getFullUrl = (filePath: string) => {
  return filePath.indexOf('hongxinshop.com') > -1
    ? filePath
    : `${window.location.protocol}//${getEnv() === 'local' ? `${getLocationEnv()}-hxjf.hongxinshop.com` : window.location.host}/image/${filePath}`
}
const downloadSrc = ({
  src,
  fileName,
  blob,
}: {
  src: string
  fileName: string
  blob?: boolean
}) => {
  if (src) {
    fileName = fileName || src.split('/')[src.split('/').length - 1]
    const a = document.createElement('a')
    a.style.display = 'none'
    document.body.appendChild(a)
    const event = new MouseEvent('click')
    a.download = fileName
    a.href = blob ? src : getFullUrl(src)

    a.target = '_blank'
    a.dispatchEvent(event)
    document.body.removeChild(a)
  }
}

// 下载文件
export async function downloadFile({
  api = '',
  blob,
  data = {},
  src,
  fileName = '',
  config = {},
}: {
  api?: string
  blob?: boolean
  data?: Record<string, any>
  src?: string
  fileName?: string
  config?: Record<string, any>
}) {
  if (src) {
    downloadSrc({ src, fileName })
    return
  }
  http
    .request<any, AxiosResponse>(api, {
      method: config.method || 'post',
      data,
      loading: true,
      responseType: blob ? 'blob' : undefined,
      responseReturn: 'raw',
      ...config,
    })
    .then((res) => {
      const { headers } = res
      if (Object.prototype.toString.call(res.data) === '[object Object]' && !res.data?.success) {
        return ElMessage.error(res.data.msg)
      }
      const data = blob?res.data:res.data?.data || res.data?.data?.url || ''
      const lowerHeaders = {}
      for (const key in headers) {
        lowerHeaders[key.toLowerCase()] = headers[key]
      }
      let src = ''
      if (blob) {
        const contentDisposition = lowerHeaders['content-disposition'] || ''
        fileName =
          fileName ||
          decodeURIComponent(contentDisposition.split('filename=')[1])
        const blob = new Blob([data], {
          type: headers['content-type'],
        })
        src = window.URL.createObjectURL(blob)
        setTimeout(() => window.URL.revokeObjectURL(src), 100) // 释放内存
      } else {
        src = data
      }
      downloadSrc({ src, fileName, blob })
    })
}

// 导入文件
export interface ImportFileOptions {
  accept?: string
  multiple?: boolean
  fieldName?: string
  api?: string
  failedFileName?: string // 导入失败时提示的文件名
  extraData?: Record<string, any> // 随文件一同发送的其他表单数据
}
export const importFile = async ({
  accept = '*',
  multiple = false,
  fieldName = 'file',
  failedFileName = '',
  extraData = {},
  api = '',
}: ImportFileOptions) => {
  return new Promise<Record<string, any>>((resolve, reject) => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = accept
    input.multiple = multiple
    const formData = new FormData()
    Object.keys(extraData).forEach((key) => {
      formData.append(key, extraData[key])
    })
    input.onchange = async (event: Event) => {
      const target = event.target as HTMLInputElement
      const files = target.files
      if (files && files.length > 0) {
        if (!multiple) {
          formData.append(fieldName, files[0])
        } else {
          Array.from(files).forEach((file, index) => {
            formData.append(`${fieldName}${index}`, file)
          })
        }
        try {
          const { data } = await http.request<any, AxiosResponse>(api, {
            method: 'post',
            data: formData,
            loading: true,
            responseReturn: 'raw',
            transformRequest: [
              function (data) {
                return data
              },
            ],
          })
          if (data.success) {
            return resolve(data.data)
          }
          if (data.code === -2) {
            const fileName =
              failedFileName ||
              data.data.split('/')[data.data.split('/').length - 1]
            const url = `${window.location.origin}/image/${data.data}`
            const failedHtml = `<div style="word-break: break-all;">失败详情：<a style="color:#409EFF;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap" title="${url}" href="${url}" download="${fileName}">${url}</a></div>`
            ElMessageBox.alert(failedHtml, '提示', {
              confirmButtonText: '确定',
              type: 'error',
              dangerouslyUseHTMLString: true,
            })
            return
          }
          return ElMessage.error(data.msg)
        } catch (error) {
          console.error(error)
        }
        input.onchange = null
      }
    }
    input.click()
  })
}

// 预览文件
export const previewFile = (url: string) => {
  url = getFullUrl(url)
  const origin = getFullUrl('').replace('/image/', '')
  const previewUrl = `${origin}/kfv/onlinePreview?url=${encode(url)}`
  window.open(previewUrl, '_blank')
}
